import { render, staticRenderFns } from "./PurchaseProduct.vue?vue&type=template&id=1f91e127&scoped=true&"
import script from "./PurchaseProduct.vue?vue&type=script&lang=js&"
export * from "./PurchaseProduct.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseProduct.vue?vue&type=style&index=0&id=1f91e127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f91e127",
  null
  
)

export default component.exports